import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function BottomUpModalHeader(_ref) {
  var children = _ref.children,
      onClose = _ref.onClose;
  return /*#__PURE__*/_jsxs("div", {
    className: "mb-6 flex items-center justify-between gap-6",
    children: [/*#__PURE__*/_jsx("h4", {
      className: "text-xl font-bold",
      children: children
    }), /*#__PURE__*/_jsx("div", {
      role: "button",
      onClick: onClose,
      children: /*#__PURE__*/_jsx(CloseRoundedIcon, {})
    })]
  });
}